/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import { Link } from "../common/Link";
import isEqual from "lodash/isEqual";
import Gettext from "../common/Gettext";
import { Info, Svg } from "./ToolsContent";

import IndicatorPopup from "./IndicatorPopup";

import ATRPopup, {
  indicatorTitle as ATRTitle,
  initialState as ATRInitialState,
} from "./ATRPopup";

import MovingAveragePopup, {
  indicatorTitle as MovingAverageTitle,
  initialState as MovingAverageInitialState,
  Info as MovingAverageInfo,
} from "./MovingAveragePopup";

import ParabolicSARPopup, {
  indicatorTitle as ParabolicSARTitle,
  initialState as ParabolicSARInitialState,
  Info as ParabolicSARInfo,
} from "./ParabolicSARPopup";

import AlligatorPopup, {
  indicatorTitle as AlligatorTitle,
  initialState as AlligatorInitialState,
  Info as AlligatorInfo,
} from "./AlligatorPopup";

import BollingerLinesPopup, {
  indicatorTitle as BollingerTitle,
  initialState as BollingerInitialState,
  Info as BollingerInfo,
} from "./BollingerLinesPopup";

import RSIPopup, {
  indicatorTitle as RSITitle,
  initialState as RSIInitialState,
} from "./RSIPopup";

import MACDPopup, {
  indicatorTitle as MACDTitle,
  initialState as MACDInitialState,
} from "./MACDPopup";

import ROCPopup, {
  indicatorTitle as ROCTitle,
  initialState as ROCInitialState,
} from "./ROCPopup";

import StochasticPopup, {
  indicatorTitle as StochasticTitle,
  initialState as StochasticInitialState,
} from "./StochasticPopup";

import type { Dispatch } from "../../redux/action";
import type { State as ReduxState } from "../../redux/reducer";
import type { State as Settings } from "../../redux/reducer/settings";

type Props = {
  title?: React.Node,
  children?: any,
  onClick?: () => void,
  isMobile?: boolean,
  settings: Settings,
  dispatch: Dispatch,
};

type State = {
  activeTool: string,
  instruments: string,
  settings: Object | null | undefined,
};

const OverheadInfo = () => (
  <Info isOverhead>
    <Svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      fill="currentColor"
      width="22"
      height="22"
    >
      <g>
        <path d="M929.9,344.8c0-57-66.5-101.7-151.3-101.7c-36.5,0-70.7,8.4-97.8,23.7c-26.6-19.7-56.6-35.2-88.8-45.4c12-27.2,18.8-58.2,18.8-87.6C610.7,48.3,555.1,10,500,10c-55.1,0-110.7,38.3-110.7,123.8c0,29.5,6.7,60.4,18.8,87.6c-32.2,10.2-62.2,25.7-88.8,45.4c-27.2-15.4-61.4-23.8-97.8-23.8c-84.9,0-151.3,44.7-151.3,101.7c0,26.3,21.4,44,63.7,52.6c24.3,4.9,54,6.7,81.2,7.4c-12.5,33.3-19.4,69.3-19.4,106.9c0,49.2,11.8,104.9,32.7,159c-16.1,4.8-32.2,11.7-47.3,20.5c-33.8,19.5-61,46.5-76.4,75.8c-16.8,31.9-18.1,63.1-3.8,87.9c5.6,9.8,14.6,16.6,26,19.6c4.8,1.3,9.9,1.9,15.4,1.9c39.4,0,96.4-31.1,160.8-68.5c0.7-0.4,1.3-0.8,2-1.2c52.9,67.1,114.9,106.1,178.3,112v54.5c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9v-54.5c63.4-5.9,125.4-44.9,178.3-112c0.7,0.4,1.3,0.8,2,1.2c64.3,37.4,121.4,68.5,160.8,68.5c5.5,0,10.6-0.6,15.4-1.9c11.4-3,20.4-9.8,26-19.6c28.5-49.4-6.7-121.3-80.2-163.7c-15.2-8.7-31.2-15.7-47.3-20.5c20.9-54,32.7-109.8,32.7-159c0-37.6-6.9-73.6-19.4-106.9c27.2-0.7,56.9-2.4,81.2-7.4C908.5,388.8,929.9,371.1,929.9,344.8z M770.6,511.6c0,6-0.2,12.1-0.6,18.3H643.6L584.7,428l107.1-107.1C740.5,369.9,770.6,437.3,770.6,511.6z M689.1,757.5L588.2,656.6l53.7-93h124.3C756,627.6,728.3,698.5,689.1,757.5z M233.6,562.3h123.8l54.5,94.3L310.9,757.5C271.4,698.1,243.6,626.6,233.6,562.3z M229.4,511.6c0-72.2,28.4-137.9,74.7-186.5l108.2,108.2l-55,95.3H229.9C229.5,522.8,229.4,517.1,229.4,511.6z M500,241c62.8,0,120.6,21.5,166.5,57.5L551.7,413.3H440L328.9,302.1C375.5,263.9,435.1,241,500,241z M443.3,643.6l-56.7-98.3l56.7-98.3h113.5l56.7,98.3l-56.7,98.3H443.3L443.3,643.6z M423.1,133.8c0-55.5,29.5-90,76.9-90c47.4,0,76.9,34.5,76.9,90c0,26.4-6.7,55.1-18.3,79.1c-19-3.7-38.6-5.7-58.6-5.7s-39.6,2-58.6,5.7C429.8,188.9,423.1,160.1,423.1,133.8z M140.5,364.3c-22.9-4.7-36.6-12-36.6-19.5c0-36.8,53.8-67.9,117.6-67.9c25.2,0,49.5,4.9,69.6,13.6c-24.6,23.2-45.3,50.5-61.1,80.8C200.7,370.9,166.5,369.6,140.5,364.3z M142.9,842.6c-2.7,0-5.3-0.3-7.5-0.9c-3.4-0.9-4.6-2.4-5.5-3.8c-8.3-14.4-6.7-34.1,4.4-55.3c12.5-23.8,35-45.9,63.4-62.3c14-8.1,28.9-14.3,43.6-18.4c11.8,25.8,25.6,50.8,41.2,74.1c0.7,1.1,1.4,2.1,2.2,3.2C242.7,803.7,175.4,842.6,142.9,842.6z M500,885.7c-63.9,0-122.7-41.5-169-100.5l107.8-107.8h122.4L669,785.2C622.7,844.2,563.9,885.7,500,885.7z M802.2,720.3c55.2,31.9,86.3,85.7,67.9,117.6c-0.8,1.5-2.1,2.9-5.5,3.8c-28.4,7.6-103.7-36-149.4-62.6c0.7-1.1,1.5-2.1,2.2-3.2c15.5-23.3,29.4-48.3,41.2-74.1C773.3,706,788.2,712.2,802.2,720.3z M770.1,371.2c-15.8-30.3-36.5-57.5-61.1-80.8c20.1-8.8,44.4-13.6,69.6-13.6c63.7,0,117.6,31.1,117.6,67.9c0,7.6-13.7,14.9-36.6,19.5C833.5,369.6,799.2,370.9,770.1,371.2z" />
      </g>
    </Svg>
    <div>
      <Gettext>
        Usage of a large quantity of analysis instruments may lead to
        performance losses and incorrect displaying of a chart.
      </Gettext>
    </div>
  </Info>
);

class ToolWrapper extends React.Component<Props, State> {
  handlePopupOpen: (_: {
    key: "Alligator" | "BollingerLines" | "MovingAverage" | "ParabolicSAR",
  }) => void;

  state = {
    activeTool: this.props.activeToolInitial || "chartType",
    instruments: this.props.instrumentsInitial || "settings",
    settings: this.props.activeToolParams
      ? this.props.settings.indicators
          .map((indicator, id) => ({ ...indicator, id }))
          .filter(
            (indicator) =>
              indicator.id === parseInt(this.props.activeToolParams[1], 10)
          )[0]
      : null,
  };

  changeActiveTool = (key: string) => {
    this.setState({
      activeTool: key,
    });
  };

  addHeikenAshi = () => {
    const newPayload = {
      type: "HeikenAshi",
      isOscillator: true,
    };
    this.onSubmit(newPayload);
  };

  handlePopupOpen = (
    key: "Alligator" | "BollingerLines" | "MovingAverage",
    settings
  ) => {
    if (key === "HeikenAshi") {
      return this.addHeikenAshi();
    }

    this.setState({ instruments: key, settings: settings });
  };

  handlePopupClose = () => {
    this.setState({ instruments: "settings" });

    if (this.props.instrumentsInitial) {
      this.props.onCompletelyClose();
    }
  };

  onSubmit = (payload) => {
    const indicators = this.props.settings.indicators.filter(
      (ind) => ind.type === payload.type
    );

    // При редактировании существующего идтикатора
    // (если получили this.props.settings)
    // у объекта удаляем id, что бы сравнение корректно отработало
    // после сравнения, id опять добавляем
    // Желающие могут отрефакторить =)

    const cleanIndicator = (_indicator) => {
      const indicator = { ..._indicator };
      if ("id" in indicator) {
        delete indicator.id;
      }
      if ("enabled" in indicator) {
        delete indicator.enabled;
      }
      return indicator;
    };

    if (this.state.settings != null) {
      if (payload === indicators[payload.id]) {
        this.handlePopupClose();
      } else {
        for (let i = 0; i < indicators.length; i++) {
          if (isEqual(cleanIndicator(payload), cleanIndicator(indicators[i])))
            return this.handlePopupClose();
        }

        payload.id = this.state.settings.id;
        payload.enabled = true;

        this.props.dispatch({
          type: "UPDATE_INDICATOR",
          payload,
        });

        this.handlePopupClose();
      }
    } else {
      for (let i = 0; i < indicators.length; i++) {
        if (isEqual(cleanIndicator(payload), cleanIndicator(indicators[i])))
          return this.handlePopupClose();
      }

      this.props.dispatch({
        type: "PUSH_INDICATOR",
        payload,
      });

      this.handlePopupClose();
    }
  };

  render() {
    const { changeActiveTool, handlePopupOpen } = this;
    const TOOLS = [
      {
        key: "chartType",
        title: <Gettext>Chart type</Gettext>,
        info: (
          <React.Fragment>
            <Gettext>
              Each chart type allows you to use some specific strategies.
            </Gettext>{" "}
            {process.env.REACT_APP_DEPLOY_TARGET !== "eztrader" && (
              <Link to="/helpdesk/skilled#strategy" target="_blank">
                <Gettext>Learn more about strategies.</Gettext>
              </Link>
            )}
          </React.Fragment>
        ),
      },
      {
        key: "lineThickness",
        title: <Gettext>Chart line</Gettext>,
        info: (
          <Gettext>Choose the thickness of a chart line in pixels.</Gettext>
        ),
      },
      {
        key: "lineColor",
        title: <Gettext>Chart color</Gettext>,
        info: (
          <Gettext>Choose a color of a chart line or zone in pixels.</Gettext>
        ),
      },
      {
        key: "interval",
        title: <Gettext>Intervals</Gettext>,
        info:
          this.props.settings.chartType === "bar" ? (
            <Gettext>Choose time interval for building one bar.</Gettext>
          ) : (
            <Gettext>Choose time interval for building one candle.</Gettext>
          ),
      },
      {
        key: "sentiments",
        title: <Gettext>"Traders' mood"</Gettext>,
        info: (
          <Gettext>
            The indicator shows a rough percentage of people choosing Upper or
            Lower options.
          </Gettext>
        ),
      },
      {
        key: "indicators",
        title: <Gettext>Indicators</Gettext>,
        info: (
          <React.Fragment>
            <Gettext>
              These tools will help you to determine how the price of an asset
              will move further.
            </Gettext>{" "}
            {process.env.REACT_APP_DEPLOY_TARGET !== "eztrader" && (
              <Link to="/helpdesk/knowledge_base#kb_i" target="_blank">
                <Gettext>Learn more about indicators.</Gettext>
              </Link>
            )}
          </React.Fragment>
        ),
      },
      {
        key: "theme",
        title: <Gettext>Themes</Gettext>,
        info: <Gettext>Choose the preferable color theme for you.</Gettext>,
        hide: process.env.REACT_APP_DEPLOY_TARGET === "eztrader",
      },
      {
        key: "sound",
        title: <Gettext>Sound effects</Gettext>,
        info: <Gettext>E.g. sound is used on operation closing events</Gettext>,
      },
      // {
      //   key: "fullscreen",
      //   title: <Gettext>Fullscreen mode</Gettext>,
      //   info: <Gettext>Fullscreen mode</Gettext>
      // }
    ];
    const activeToolObj = TOOLS.find(
      (tool) => tool.key === this.state.activeTool
    );

    const POPUPS = {
      ATR: {
        template: ATRPopup,
        title: ATRTitle,
        initialState: ATRInitialState,
        validation: {
          period: (period) => period > 0,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "ATR",
            isOscillator: true,
          };
          this.onSubmit(newPayload);
        },
      },
      RSI: {
        template: RSIPopup,
        title: RSITitle,
        initialState: RSIInitialState,
        validation: {
          period: (period) => period > 0,
          oversold: (oversold) => oversold > 0 && oversold < 100,
          overbought: (overbought) => overbought > 0 && overbought < 100,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "RSI",
            isOscillator: true,
          };
          this.onSubmit(newPayload);
        },
      },
      MACD: {
        template: MACDPopup,
        title: MACDTitle,
        initialState: MACDInitialState,
        validation: {
          fastPeriod: (fastPeriod) => fastPeriod > 0,
          slowPeriod: (slowPeriod) => slowPeriod > 0,
          period: (period) => period > 0,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "MACD",
            isOscillator: true,
          };
          this.onSubmit(newPayload);
        },
      },
      ROC: {
        template: ROCPopup,
        title: ROCTitle,
        initialState: ROCInitialState,
        validation: {
          period: (period) => period > 0,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "ROC",
            isOscillator: true,
          };
          this.onSubmit(newPayload);
        },
      },
      Stoch: {
        template: StochasticPopup,
        title: StochasticTitle,
        initialState: StochasticInitialState,
        validation: {
          periodK: (periodK) => periodK > 0,
          periodD: (periodD) => periodD > 0,
          slowing: (slowing) => slowing > 0,
          overbought: (overbought) => overbought > 0 && overbought < 100,
          oversold: (oversold) => oversold > 0 && oversold < 100,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "Stoch",
            isOscillator: true,
          };
          this.onSubmit(newPayload);
        },
      },
      MovingAverage: {
        template: MovingAveragePopup,
        title: MovingAverageTitle,
        initialState: MovingAverageInitialState,
        validation: {
          period: (period) => period > 0,
        },
        info: MovingAverageInfo,
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "MovingAverage",
            shift: 0,
            rejection: 0,
          };
          this.onSubmit(newPayload);
        },
      },
      ParabolicSAR: {
        template: ParabolicSARPopup,
        title: ParabolicSARTitle,
        initialState: ParabolicSARInitialState,
        info: ParabolicSARInfo,
        validation: {
          accelerationStep: (accelerationStep) =>
            parseFloat(accelerationStep) > 0,
          accelerationMaxValue: (accelerationMaxValue) =>
            parseFloat(accelerationMaxValue) > 0,
        },
        onSubmit: (payload) => {
          const newPayload = {
            ...payload,
            type: "ParabolicSAR",
            shift: 0,
            rejection: 0,
          };
          this.onSubmit(newPayload);
        },
      },
      Alligator: {
        template: AlligatorPopup,
        title: AlligatorTitle,
        initialState: AlligatorInitialState,
        validation: {
          jaws_period: (jaws_period) => jaws_period > 0,
          jaws_shift: (jaws_shift) => jaws_shift > 0,
          teeths_period: (teeths_period) => teeths_period > 0,
          teeths_shift: (teeths_shift) => teeths_shift > 0,
          lips_period: (lips_period) => lips_period > 0,
          lips_shift: (lips_shift) => lips_shift > 0,
        },
        info: AlligatorInfo,
        onSubmit: (payload) => {
          const defaultLine = {
            type: "MovingAverage",
            algorithm: "SMA",
            period: 0,
            shift: 0,
            rejection: 0,
          };

          const newPayload = {
            type: "Alligator",
            enabled: payload.enabled,
            jaws: { ...defaultLine, ...payload.jaws },
            teeths: { ...defaultLine, ...payload.teeths },
            lips: { ...defaultLine, ...payload.lips },
          };

          this.onSubmit(newPayload);
        },
      },
      BollingerLines: {
        template: BollingerLinesPopup,
        title: BollingerTitle,
        initialState: BollingerInitialState,
        validation: {
          period: (period) => period > 0,
          rejection: (rejection) => rejection > 0,
        },
        info: BollingerInfo,
        onSubmit: (payload) => {
          const defaultLine = {
            type: "MovingAverage",
            algorithm: "SMA",
            period: payload.period,
            shift: 0,
            rejection: 0,
          };

          const newPayload = {
            type: "BollingerLines",
            enabled: payload.enabled,
            period: payload.period,
            rejection: payload.rejection,
            upper: {
              ...defaultLine,
              rejection: payload.rejection,
              strokeWidth: payload.upper.strokeWidth,
              color: payload.upper.color,
            },
            middle: {
              ...defaultLine,
              strokeWidth: payload.middle.strokeWidth,
              color: payload.middle.color,
            },
            lower: {
              ...defaultLine,
              rejection: -payload.rejection,
              strokeWidth: payload.lower.strokeWidth,
              color: payload.lower.color,
            },
          };

          this.onSubmit(newPayload);
        },
      },
    };

    const activeIndicatorsLength = this.props.settings.indicators.filter(
      (indicator) => indicator.enabled !== false
    ).length;
    const isOverhead =
      (this.props.isMobile && activeIndicatorsLength >= 2) ||
      activeIndicatorsLength >= 3;

    const Popup = POPUPS[this.state.instruments] || null;

    const popup = Popup && (
      <IndicatorPopup
        onClose={this.handlePopupClose}
        mobile={this.props.isMobile}
        onSubmit={Popup.onSubmit}
        info={isOverhead ? <OverheadInfo /> : Popup.info || null}
        initialState={this.state.settings || Popup.initialState}
        title={Popup.title}
        validation={Popup.validation}
      >
        {({
          indicator,
          errors,
          activeSelect,
          handleClick,
          handleChange,
          handleAsIsChange,
          handleNumberChange,
          handleNestedChange,
        }) => (
          <Popup.template
            indicator={indicator}
            errors={errors}
            activeSelect={activeSelect}
            handleClick={handleClick}
            handleChange={handleChange}
            handleAsIsChange={handleAsIsChange}
            handleNumberChange={handleNumberChange}
            handleNestedChange={handleNestedChange}
          />
        )}
      </IndicatorPopup>
    );

    return this.props.children && typeof this.props.children === "function"
      ? this.props.children({
          TOOLS,
          changeActiveTool,
          activeToolObj,
          handlePopupOpen,
          popup,
          ...this.state,
          ...this.props,
        })
      : null;
  }
}

function mapStateToProps({ settings }: ReduxState) {
  return {
    settings: settings,
  };
}

export default connect(mapStateToProps)(ToolWrapper);



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolWrapper.js